<template>
  <div class="human-resource">
    <div>
      <div class="title">人力部署</div>
      <el-radio-group
        v-model="tabPosition"
        class="special-radio"
        size="mini"
        @input="tabChangeRadio"
      >
        <el-radio-button label="top">网格员人力</el-radio-button>
        <el-radio-button label="left">职能部门人力</el-radio-button>
      </el-radio-group>
      <div
        v-if="tabPosition == 'top'"
        style="width: 312px; height: 200px; margin-top: 12px"
      >
        <wgEchart :options="humanResourceOneList" id="humanResourceOne"></wgEchart>
      </div>
      <div
        v-if="tabPosition == 'left'"
        style="width: 312px; height: 200px; margin-top: 10px"
      >
        <wgEchart :options="functionalDepartList" id="functionalDepart"></wgEchart>
      </div>
    </div>
  </div>
</template>
<script>
import wgEchart from "@/components/wgEchart/wgEchart.vue";
import titleInternal from "@/pages/patrolScreenMini/components/title-internal.vue";
import { getResourcePerson } from "@/api/daping.js";
export default {
  name: "index",
  components: {
    wgEchart,
    titleInternal,
  },
  data() {
    return {
      tabPosition: "top",
      humanResourceOneList: {},
      functionalDepartList: {}
    };
  },
  mounted() {
    this.getResourcePerson(1);
  },
  methods: {
    async getResourcePerson(type) {
      const res = await getResourcePerson({
        type: type
      })
      if (res.data.code == 200) {
        if (type == 1) {
          this.optionsListData(res.data.data)
        } else {
          this.optionsListDataBottom(res.data.data)
        }
      }
    },
    optionsListData(dataList) {
      var trafficWay = [];
      dataList.forEach(item => {
        trafficWay.push({
          name: item.deptName,
          value: item.userCount,
        })
      })
      var color = [
        "#46ABFF",
        "#01E8FE",
        "#3359F4",
        "#63DAA1",
        "#F7B467",
        "#EA9B86",
        "#ACCEEA",
        "#DC614D",
      ];
      var seriesOption = [
        {
          name: "",
          type: "pie",
          radius: ["48%", "58%"],
          hoverAnimation: true,
          padAngle: 2,
          roseType: "area",
          itemStyle: {
            normal: {
              label: {
                show: true,
                position: "outside",
                color: "#ADC2D3",
                fontSzie: "14px",
                formatter: function (params) {
                  var percent = 0;
                  var total = 0;
                  for (var i = 0; i < trafficWay.length; i++) {
                    total += trafficWay[i].value;
                  }
                  percent = ((params.value / total) * 100).toFixed(0);
                  if (params.name !== "") {
                    return params.name + "\n" + params.value;
                  } else {
                    return "";
                  }
                },
              },
              labelLine: {
                length: 10,
                length2: 30,
                show: true,
              },
            },
          },
          data: trafficWay,
        },
        {
          type: "pie",
          name: "内层细圆环",
          radius: ["62%", "63%"],
          hoverAnimation: false,
          clockWise: false,
          itemStyle: {
            normal: {
              color: "#0d3260",
            },
          },
          label: {
            show: false,
          },
          tooltip: {
            trigger: false
          },
          data: [0],
        },
      ];
      let option = {
        color: color,
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c}",
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
        },
        legend: {
          show: false,
        },
        series: seriesOption,
      };

      this.humanResourceOneList = option;
    },
    optionsListDataBottom(dataList) {
      let dateArr = dataList.map(item => item.deptName)
      let gzhArr = dataList.map(item => item.userCount)
      let option = {
        grid: {
          left: "22%",
          right: "6%",
          top: "6%",
          bottom: "12%"
        },
        legend: {
          show: false,
          itemWidth: 14,
          itemHeight: 6,
          // itemGap:50,
          right: 10,
          textStyle: {
            color: "#E4F2FF",
            fontSize: 14,
          },
        },
        tooltip: {
          // show: true,
          // trigger: "item",
          // formatter: "{b}: {c}",
          backgroundColor: "rgba(3,9,24,0.7)",
          borderColor: "rgba(3,9,24,0.7)",
          textStyle: {
            color: "#fff",
          },
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (param) {
            let res = param[0].name;
            for (let j = 0; j < param.length; j++) {
              // 渐变色导致提示框中颜色消失,额外定义
              res += param[j].seriesName + ": " + param[j].value + "<br>";
            }
            return res;
          },
        },
        xAxis: {
          type: "value",
          // "max": max,
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(172, 206, 234, 0.2)",
              type: "dashed",
            },
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "#ADC2D3",
              fontSize: 14,
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            data: dateArr,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              // "margin": 10,
              textStyle: {
                color: "#ADC2D3",
                fontSize: 14,
              },
              formatter: function (params) {
                var index = 3; //字数为6个超出就显示成点
                var newstr = "";
                for (var i = 0; i < params.length; i += index) {
                  var tmp = params.substring(i, i + index);
                  newstr += tmp + "";
                }
                if (newstr.length > 3) return newstr.substring(0, 3) + "...";
                else return newstr;
              },
            },
          },
        ],
        dataZoom: [
          {
            // 设置滚动条的隐藏或显示
            show: true,
            // 设置类型
            type: "slider",
            // 设置背景颜色
            backgroundColor: "rgb(19, 63, 100)",
            // 设置选中范围的填充颜色
            fillerColor: "rgb(16, 171, 198)",
            // 设置边框颜色
            borderColor: "rgb(19, 63, 100)",
            // 是否显示detail，即拖拽时候显示详细数值信息
            showDetail: false,
            // 数据窗口范围的起始数值
            startValue: 0,
            // 数据窗口范围的结束数值（一页显示多少条数据）
            endValue: 7,
            // 控制哪个轴，如果是number表示控制一个轴，
            // 如果是Array表示控制多个轴。此处控制第二根轴
            yAxisIndex: [0, 1],
            // empty：当前数据窗口外的数据，被设置为空。
            // 即不会影响其他轴的数据范围
            filterMode: "empty",
            // 滚动条高度
            width: 8,
            // 滚动条显示位置
            height: "80%",
            // 距离右边
            right: 3,
            // 控制手柄的尺寸
            handleSize: 0,
            // 是否锁定选择区域（或叫做数据窗口）的大小
            zoomLoxk: true,
            // 组件离容器上侧的距离
            // 如果top的值为'top', 'middle', 'bottom'，组件会根据相应的位置自动对齐
            top: "middle",
          },
          {
            // 没有下面这块的话，只能拖动滚动条，
            // 鼠标滚轮在区域内不能控制外部滚动条
            type: "inside",
            // 控制哪个轴，如果是number表示控制一个轴，
            // 如果是Array表示控制多个轴。此处控制第二根轴
            yAxisIndex: [0, 1],
            // 滚轮是否触发缩放
            zoomOnMouseWheel: false,
            // 鼠标移动能否触发平移
            moveOnMouseMove: true,
            // 鼠标滚轮能否触发平移
            moveOnMouseWheel: true,
          },
        ],
        series: [
          {
            //内2
            type: "bar",
            barWidth: 6,
            name: "",
            legendHoverLink: false,
            silent: true,
            label: {
              show: false,
              position: "right",
              textStyle: {
                color: "#fff",
                padding: [0, 10],
                fontSize: 16,
                rich: {
                  a: {
                    color: "#fff",
                    fontSize: 36,
                  },
                },
              },
            },
            itemStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(0,163,255,0)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#00A3FF", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              }, //底色
            },
            data: gzhArr,
            zlevel: 11,
          },
          // {
          //   data: [200, 200, 200, 200, 200],
          //   type: "custom",
          //   xAxisIndex: 0,
          //   barGap: "-100%",
          //   silent: true,
          //   barWidth: 20,
          //   itemStyle: {
          //     normal: {
          //       color: "rgba(255,255,255,0.1)",
          //     },
          //   },
          //   zlevel: 9,
          // },
        ],
      };
      this.functionalDepartList = option;
    },
    tabChangeRadio(val) {
      this.getResourcePerson(val == 'top' ? 1 : 2)
    },
  },
};
</script>
<style scoped lang="less">
.flex-just {
  display: flex;
  justify-content: space-between;
}
.title {
  font-family: MiSans, MiSans;
  font-weight: 600;
  font-size: 14px;
  color: #f3f8ff;
  line-height: 19px;
  text-align: left;
  font-style: normal;
  background: linear-gradient(180deg, #ddefff 0%, #5bacef 100%);
  color: transparent;
  /* 使用背景渐变填充文字 */
  -webkit-background-clip: text;
  background-clip: text;
  text-shadow: 0px 4px 8px rgba(3, 9, 24, 0.2);
  margin: 14px 0 0 12px;
}

.special-radio {
  height: 22px;
  position: absolute;
  top: -4px;
  right: 12px;
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: linear-gradient(315deg, #006aff 0%, #00a3ff 100%);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #ffffff;
    padding: 4px 6px;
  }
  /deep/ .el-radio-button__inner {
    background: rgba(4, 20, 50, 0.4);
    border: 1px solid rgba(0, 163, 255, 0.3);
    color: #00a3ff;
    padding: 4px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/left/humanResourceDeployment.vue